import React from 'react';

export const faNumber = (value) => value == null || value === '' || !Number.isFinite(Number(value))
    ? '—' : Number(value).toLocaleString('fa-IR');
export const ratioOf = (value, status) => {
    if (value == null || value === '' || status === 'unassessed') return null;
    const number = Number(value);
    return Number.isFinite(number) && number >= 0 && number <= 1 ? number : null;
};
export const faPercent = (value, status) => {
    const ratio = ratioOf(value, status);
    return ratio == null ? 'هنوز ارزیابی نشده' : `${Math.round(ratio * 100).toLocaleString('fa-IR')}٪`;
};
export const faDate = (value) => {
    if (!value) return 'شاهدی ثبت نشده';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? 'زمان نامشخص'
        : new Intl.DateTimeFormat('fa-IR', {dateStyle: 'medium', timeStyle: 'short'}).format(date);
};

export function MasteryVisual({value, status, compact = false}) {
    const ratio = ratioOf(value, status);
    if (ratio == null) return <span className="als-unassessed">هنوز ارزیابی نشده</span>;
    return <div className={`als-mastery-visual ${compact ? 'compact' : ''}`} aria-label={`تسلط: ${faPercent(value, status)}`}>
        <span className="als-mastery-track"><span style={{width: `${ratio * 100}%`}}/></span>
        <strong>{faPercent(value, status)}</strong>
    </div>;
}

export function CoverageVisual({assessed, total, value}) {
    const knownTotal = Number(total);
    const knownAssessed = Number(assessed);
    if (!Number.isFinite(knownTotal) || knownTotal <= 0) return <span className="als-coverage-note">مفهومی نگاشت نشده</span>;
    const shown = Math.min(knownTotal, 12);
    const filled = Number.isFinite(knownAssessed) ? Math.round(Math.min(1, knownAssessed / knownTotal) * shown) : 0;
    return <div className="als-coverage-visual" aria-label={`پوشش مفاهیم: ${faNumber(assessed)} از ${faNumber(total)}`}>
        <span className="als-coverage-segments" aria-hidden="true">{Array.from({length: shown}, (_, index) => <i key={index} className={index < filled ? 'on' : ''}/>)}</span>
        <small>{faNumber(assessed)} از {faNumber(total)} مفهوم{ratioOf(value) != null ? ` · ${faPercent(value)}` : ''}</small>
    </div>;
}

export function SnapshotTiles({items}) {
    return <div className="als-snapshot-tiles">{items.map((item) => <div className="als-snapshot-tile" key={item.label}>
        <span className="als-tile-label">{item.label}</span>
        {item.kind === 'mastery' ? <MasteryVisual value={item.value} status={item.status}/>
            : item.kind === 'coverage' ? <CoverageVisual assessed={item.assessed} total={item.total} value={item.value}/>
                : <strong className="als-tile-value">{item.value}</strong>}
        {item.description && <small>{item.description}</small>}
    </div>)}</div>;
}

export function Freshness({at, onRefresh}) {
    return <div className="als-freshness"><button type="button" onClick={onRefresh}>بازخوانی داده</button>
        <small>آخرین دریافت: {at ? new Intl.DateTimeFormat('fa-IR', {dateStyle: 'short', timeStyle: 'short'}).format(at) : '—'}</small>
    </div>;
}
